import React from 'react';
import PropTypes from 'prop-types';
import { DtpModal } from 'dtp-react-components';

const Modal = (props) => {
  const modalContent = (
    <DtpModal.DtpModalContent>
      {props.conteudomodal}
    </DtpModal.DtpModalContent>
  );

  const modalFooter = (
    <DtpModal.DtpModalFooter>
      {props.conteudofooter}
    </DtpModal.DtpModalFooter>
  );

  return (
    <DtpModal
      {...props}
      show={props.showModal}
    >
      {modalContent}
      {props.conteudofooter && modalFooter}
    </DtpModal>
  );
};

Modal.propTypes = {
  // Conteúdo exibido no corpo do modal
  conteudomodal: PropTypes.element.isRequired,
  // Conteúdo exibido na rodapé do modal
  conteudofooter: PropTypes.element.isRequired,
  // Altera o tamanho do modal [Pequeno -> 'sm', Médio -> 'md', Grande -> 'lg']
  size: PropTypes.string,
  // Exibe o modal
  showModal: PropTypes.bool.isRequired,
};

Modal.defaultProps = {
  size: 'lg',
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/Modal.jsx